import { BookOpenIcon, ClipboardCheckIcon, LockIcon, SearchIcon, TableIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Steam Tables, Heat Transfer Formulas & Unit Conversions Quick Reference',
    description: 'Key steam table values, heat transfer formulas and unit conversions gathered in one PDF reference.',
    icon: TableIcon,
  },
  {
    number: '2',
    title: 'Boiler Room Daily Checks, Startup & Shutdown Checklists',
    description: 'Printable PDF checklists for daily rounds, startup and shutdown in the boiler room.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: 'Boiler & Heat Exchanger Troubleshooting Guide',
    description: 'Common symptoms in boilers and heat exchangers, their likely causes and what to check first.',
    icon: SearchIcon,
  },
  {
    number: '4',
    title: 'Boilers & Heat Exchangers Glossary & Abbreviations Handbook',
    description: 'An A–Z reference of the terms and abbreviations used around boilers, steam and heat exchangers.',
    icon: BookOpenIcon,
  },
  {
    number: '5',
    title: 'Boiler Room Safety & Lockout/Tagout Field Handbook',
    description: 'A field handbook covering boiler room hazards and the basic lockout/tagout sequence.',
    icon: LockIcon,
  },
];
